<div class="filter-group" *ngIf="hasSubcategoryOptions">
  <div class="filter-group__header">
    <div class="filter-group__title">
      {{ 'common.type' | i18n }}
    </div>

    <button
      class="filter-group__reset"
      *ngIf="canReset"
      (click)="resetSubcategories()"
    >
      {{ 'filters.common.reset' | i18n }}
    </button>
  </div>

  <div class="filter-group__main">
    <ul
      class="subcategory-options"
      [tabIndex]="tabIndex"
      cdkMonitorSubtreeFocus
      (cdkFocusChange)="onFocusChange($event)"
      (keydown)="onKeydown($event)"
    >
      <li
        class="subcategory-options__option"
        *ngFor="let option of visibleOptions; trackBy: trackBy; let i = index"
      >
        <lib-labelled-checkbox>
          <ng-template let-id="id">
            <lib-checkbox
              [id]="id"
              [isChecked]="option.isChecked"
              [tabIndex]="-1"
              (update)="toggleSubcategory(option, $event, i)"
            ></lib-checkbox>
          </ng-template>

          {{ option.text | i18n }}
        </lib-labelled-checkbox>
      </li>
    </ul>

    <div class="expand-button-wrapper">
      <button
        class="expand-button"
        *ngIf="canExpand"
        (click)="toggleExpanded()"
        [class.expand-button--expanded]="isExpanded"
      >
        <span class="expand-button__text">
          <ng-container *ngIf="isExpanded; else showMore">
            {{ 'common.showLess' | i18n }}
          </ng-container>
          <ng-template #showMore>
            {{ 'common.showMore' | i18n }}
          </ng-template>
        </span>
        <i class="expand-button__icon material-icon"> keyboard_arrow_down </i>
      </button>
    </div>
  </div>
</div>
